import styled, { css } from 'styled-components'

interface ContainerProps {
  variant: 'default' | 'primary'
}

export const Container = styled.span<ContainerProps>`
  ${({ theme, variant }) => css`
    display: flex;
    align-items: center;
    gap: 0.25rem;

    color: var(--sl-fg-base);
    border: 0.5px solid ${theme.colors.inative};
    background-color: var(--sl-bg-base-strong);
    border-radius: ${theme.border.radius.small};
    padding: 0.25rem 0.75rem;
    width: fit-content;

    ${variant === 'primary' &&
    css`
      border-color: color-mix(in srgb, var(--primary) 10%, transparent);
      background-color: color-mix(in srgb, var(--primary) 2%, transparent);
    `}

    .text {
      font-size: 0.5rem;
      font-weight: 700;
      text-transform: uppercase;

      ${variant === 'primary' &&
      css`
        color: var(--primary);
      `};
    }
  `}
`
